var React = require('react');

function BulletProof (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6.5 15.898S13 13.041 13 8.942V1.986s-.393.056-1.008.056C10.632 2.043 8.183 1.768 6.5 0 4.817 1.768 2.368 2.043 1.007 2.043.392 2.043 0 1.987 0 1.987v6.956c0 4.099 6.5 6.955 6.5 6.955zM.994 3.037h.014c1.309 0 3.628-.238 5.493-1.699 1.865 1.461 4.183 1.699 5.493 1.699h.014v5.906c0 2.615-3.664 4.954-5.507 5.859C4.655 13.9.994 11.566.994 8.943V3.037z","key":0}),React.createElement("path",{"d":"M6.5 13.396V2.813s1.807.917 4.654.917v5.5s-1.099 3.416-4.654 4.166z","key":1})]);
}

BulletProof.defaultProps = {"width":"13","height":"15.898","viewBox":"0 0 13 15.898"};

module.exports = BulletProof;

BulletProof.default = BulletProof;
